import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Modal, Table} from "react-bootstrap";
import axios from 'axios';

let baseUrl = 'https://b316wmuwh1.execute-api.us-east-1.amazonaws.com/default/mostrar_btn_info_standar'
axios.defaults.headers.post['authorizationToken'] = '&S396b<eg5Zn(HiLe)BBNtc&';


class MostrarInfo extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            obserbaciones_contacto: [],
            id_gestion: this.props.id_gestion,
        };
    }

    async componentDidMount() {
        
        //console.log('llamo servicio mostrar obserbacion')
        //console.log('valido dato:  ' +this.props.data)
        const body = JSON.stringify({
            con_id: this.props.id_gestion
        })
        //console.log(body)
        await axios.post(baseUrl,body)
            .then(response => {
                //console.log('exito get_evaluadores: ' + JSON.stringify(response.data));
                this.setState({obserbaciones_contacto:response.data});
                //console.log(response)
            })
            .catch(response => {
                console.log(response + ' error get_evaluadores')
            }
        )
        
    }

    render(){
        const { obserbaciones_contacto } = this.state;
        //console.log('length evaluadores: '+evaluadores.length)
        let contactoList = obserbaciones_contacto.length > 0
            && obserbaciones_contacto.map((item, i) => {
                return (
                    <tr key={i++}>
                        <td>{i+1}</td>
                        <td>{item.tipo}</td>
                        <td>{item.rut}</td>
                        <td>{item.nombre+' '+item.paterno}</td>
                        <td>{item.fechanacimiento}</td>
                        <td>{item.parentesco}</td>
                        <td>{item.porcentaje}</td>
                    </tr>
                )
            }, this);
        return(
            <Container>
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Informacion
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Table striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Tipo agregado</th>
                                <th>Rut</th>
                                <th>Nombre Completo</th>
                                <th>Fecha Nacimiento</th>
                                <th>Parentesco</th>
                                <th>Porcentaje</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contactoList}
                        </tbody>
                        </Table>
                    </Modal.Body>
            </Container>
        )
    }
}
export default MostrarInfo;